// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 3436) return "static/chunks/3436-877a91ae4dccd483.js";
	if (chunkId === 4413) return "static/chunks/4413-6dd8709b82dc7ea7.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 464 ? "2e9fb43f" : chunkId) + "." + {"464":"c7d2b11e670d094f","2366":"9b59da60674e99fa","4116":"bb73130c8b6274f5","6116":"60863a4ecb924545","7855":"c1a5bc46a6bd3660","7935":"35a4f2d82921ec93","9957":"bf796d5c687ba0fd"}[chunkId] + ".js";
};